import Promise from 'bluebird';
import isNil from 'lodash/isNil';
import forEach from 'lodash/forEach';
import getNotificationPoller from '../common/notification-poller';
import retrieveNotifications from './retrieve-notifications';
import { applyFilter } from './filter-actions';

function getFilterData() {
	// return {"name":null,"expressions":[{"var":"patient.subscriber.aco","op":"equals","valueType":"text","value":"uuuu"},{"var":"raw.AACode","op":"equals","valueType":"text","value":["kkkk"]}]};
	if (!isNil(window.location.search)) {
		const searchParams = new URLSearchParams(window.location.search);
		try {
			return JSON.parse(searchParams.get('filter'));
		} catch (error) {
			return null;
		}
	} else {
		return null;
	}
}

/**
 * Calls all services needed to initialize the notifications page. Wait until all filter and settings
 * data is retrieved before performing the initial call to retrieve notifications. Get the export task
 * asynchronously.
 */
export default function initializeNotificationsPage(
	context,
	{ removeQueryParams }
) {
	getNotificationPoller(context).stop();

	const {
		service: {
			retrieveFilterConfig, retrieveFilters, retrieveQuickFilters, retrieveSettings, getExportTask
		},
		executeAction,
		notify,
	} = context;

	const initialServiceCallPromises = [
		Promise.fromCallback((resolve) => retrieveFilterConfig({}, resolve)),
		Promise.fromCallback((resolve) => retrieveFilters({}, resolve)),
		Promise.fromCallback((resolve) => retrieveQuickFilters({}, resolve)),
		Promise.fromCallback((resolve) => retrieveSettings({}, resolve)),
	];

	getExportTask({ options: { showModalIfComplete: true } });

	Promise.all(initialServiceCallPromises).then((serviceInstances) => {
		// Wait to pefrom the initial notification load until filters, filter config,
		// quick filter and settings are retrieved. If filter query params are present
		// then apply the filter before retrieving notifications.
		const failedRequests = [];

		forEach(serviceInstances, (service) => {
			if (service.status !== 2) {
				// If the service status is not 2 (meaning success), then this service call failed.
				failedRequests.push(service.id);
			}
		});

		if (failedRequests.length > 0) {
			notify.error({
				message: `Initialization requests failed: ${failedRequests.join(', ')}`,
			});

			return;
		}

		const filterData = getFilterData();

		if (isNil(filterData)) {
			executeAction(retrieveNotifications);
		} else {
			executeAction(applyFilter, filterData);

			removeQueryParams();
		}
	});
}
